import { ArrowRight } from "lucide-react";
import { BRAND, Reveal } from "./shared";

export default function Hero({ onBookClick }) {
  return (
    <section id="top" className="relative pt-28 md:pt-36 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow">Online Strength Coaching</p>
            </Reveal>
            <Reveal delay={80}>
              <h1 className="font-serif text-brand-ink mt-6 text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
                Strength can be
                <br />
                built <em className="italic text-brand-accent">anywhere.</em>
              </h1>
            </Reveal>
            <Reveal delay={160}>
              <p className="mt-8 text-lg md:text-xl text-brand-ink2 max-w-xl leading-relaxed font-sans">
                You don't need an expensive gym. You need the right guidance,
                a structured plan, and someone in your corner. Train from home
                or outdoors — get stronger for life.
              </p>
            </Reveal>
            <Reveal delay={240}>
              <div className="mt-10 flex flex-wrap items-center gap-4">
                <button
                  onClick={onBookClick}
                  className="btn-accent"
                  data-testid="hero-book-btn"
                >
                  Book a Free Consultation
                  <ArrowRight className="h-4 w-4" />
                </button>
                <a href="#how" className="btn-outline" data-testid="hero-how-link">
                  How it works
                </a>
              </div>
            </Reveal>
            <Reveal delay={320}>
              <div className="mt-12 flex items-center gap-8 text-sm text-brand-ink2">
                <div>
                  <div className="font-serif text-2xl text-brand-ink">9+</div>
                  <div className="uppercase tracking-widest text-xs mt-1">Yrs coaching</div>
                </div>
                <div className="h-8 w-px bg-brand-border" />
                <div>
                  <div className="font-serif text-2xl text-brand-ink">10000+</div>
                  <div className="uppercase tracking-widest text-xs mt-1">Clients guided</div>
                </div>
                <div className="h-8 w-px bg-brand-border" />
                <div>
                  <div className="font-serif text-2xl text-brand-ink">0</div>
                  <div className="uppercase tracking-widest text-xs mt-1">Gym required</div>
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={200} className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border border-brand-accent/60 hidden md:block z-10" />
              <img
                src={BRAND.hero}
                alt="Aditya training with resistance band"
                className="w-full h-[420px] md:h-[560px] object-cover"
                data-testid="hero-image"
              />
              <div className="absolute -bottom-6 -right-4 bg-brand-surfaceAlt px-6 py-5 max-w-[260px] hidden md:block border border-brand-border z-20">
                <p className="font-serif italic text-brand-ink leading-snug">
                  "No fancy gym. No shortcuts. Just strength."
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
